export const th = {
  // Common
  "common.back": "กลับ",
  "common.cancel": "ยกเลิก",
  "common.noItems": "ไม่มีรายการ",
  "common.loading": "กำลังโหลด...",
  
  // Header
  "nav.features": "คุณสมบัติ",
  "nav.howItWorks": "วิธีการทำงาน",
  "nav.pricing": "ราคา",
  "nav.faq": "คำถามที่พบบ่อย",
  "nav.testimonials": "โชว์เคส",
  "nav.contact": "ติดต่อ",
  "button.getStarted": "เริ่มต้น",
  "button.loading": "กำลังโหลด...",

  // Auth related
  "auth.signIn": "เข้าสู่ระบบ",
  "auth.redirecting": "กำลังเปลี่ยนเส้นทาง...",
  "auth.continueWithGoogle": "ดำเนินการต่อด้วย Google",
  "auth.continueWithGithub": "ดำเนินการต่อด้วย GitHub",
  "auth.or": "หรือ",
  "auth.consent.prefix": "การดำเนินการต่อแสดงว่าคุณยอมรับ",
  "auth.consent.terms": "ข้อกำหนด",
  "auth.consent.and": "และ",
  "auth.consent.privacy": "นโยบายความเป็นส่วนตัว",

  // Site Title
  "site.title": "Communicate to Win",
  "site.title.first": "Communicate",
  "site.title.second": "to Win",
  "site.title.translated": "沟通制胜",

  // Hero Section
  "hero.title": "ผู้ช่วยการสื่อสารด้วย AI",
  "hero.subtitle": "เปลี่ยนการสนทนาของคุณด้วยการตอบสนองที่ชาญฉลาดและตระหนักถึงบริบท ช่วยให้คุณสื่อสารได้อย่างมีประสิทธิภาพมากขึ้นในทุกสถานการณ์",
  "hero.cta.primary": "ทดลองใช้ฟรี",
  "hero.cta.secondary": "ดูเดโม",
  "hero.cta.tryNow": "เริ่มต้นใช้งานฟรี",
  "hero.cta.learnMore": "เรียนรู้เพิ่มเติม",
  "hero.cta.getStarted": "เริ่มต้นใช้งานฟรี",
  "hero.preview.primary": "ปรับปรุงน้ำเสียง",
  "hero.preview.secondary": "แปลภาษา",
  "hero.preview.tone": "เป็นมิตร",
  "hero.preview.target": "ลูกค้า",
  "hero.hook": "เข้าร่วมกับผู้ใช้หลายพันคนที่ปรับปรุงการสื่อสารของพวกเขาทุกวัน",
  "hero.headline": "ผู้ช่วยการสื่อสารด้วย AI",
  "hero.subheadline": "เปลี่ยนไอเดียดิบให้เป็นคำตอบที่เรียบเรียงและเข้าใจบริบทในไม่กี่วินาที",
  
  // Stats
  "stats.users": "ผู้ใช้",
  "stats.replies": "คำตอบ",
  "stats.languages": "ภาษา",

  // Main Title
  "main.title": "เปลี่ยนทุกคำตอบให้เป็นโอกาส",

  // Footer Section
  "footer.company": "บริษัท",
  "footer.product": "ผลิตภัณฑ์",
  "footer.support": "สนับสนุน",
  "footer.legal": "กฎหมาย",
  "footer.contactSupport": "ติดต่อฝ่ายสนับสนุน",
  "footer.helpCenter": "ศูนย์ช่วยเหลือ",
  "footer.apiDocs": "เอกสาร API",
  "footer.statusPage": "หน้าสถานะ",
  "footer.privacyPolicy": "นโยบายความเป็นส่วนตัว",
  "footer.termsOfService": "ข้อกำหนดการใช้บริการ",
  "footer.cookiePolicy": "นโยบายคุกกี้",
  "footer.refundPolicy": "นโยบายการคืนเงิน",
  "footer.copyright": "© 2025 DOUBLEWIND LTD. All rights reserved.",
  "footer.supportLabel": "สนับสนุน",

  // Features Section
  "features.badge": "คุณสมบัติที่ทรงพลัง",
  "features.title": "ทุกสิ่งที่คุณต้องการสำหรับการสื่อสารที่ดีขึ้น",
  "features.subtitle": "เครื่องมือครบครันที่ออกแบบมาเพื่อทำให้ทุกการสนทนามีประสิทธิภาพและเป็นมืออาชีพมากขึ้น",
  "features.scenario.title": "เทมเพลตสถานการณ์",
  "features.scenario.description": "เทมเพลตที่สร้างไว้ล่วงหน้าสำหรับการสื่อสารในที่ทำงาน ส่วนตัว วิชาการ และมืออาชีพ",
  "features.custom.title": "ข้อมูลที่กำหนดเอง",
  "features.custom.description": "วางข้อความหรือเนื้อหาใดๆ และรับคำตอบที่เหมาะสมกับบริบท",
  "features.instant.title": "ลดเวลาตอบกลับ 90%",
  "features.instant.description": "รับคำตอบที่สร้างด้วย AI ในไม่กี่วินาที ไม่ต้องรอ แค่ผลลัพธ์",
  "features.copy.title": "คัดลอกและแชร์ในคลิกเดียว",
  "features.copy.description": "คัดลอกคำตอบทันทีหรือแชร์โดยตรงจากแพลตฟอร์ม",

  // How It Works Section
  "howItWorks.badge": "วิธีการทำงาน",
  "howItWorks.title": "สามขั้นตอนง่ายๆ สู่การสื่อสารที่ดีขึ้น",
  "howItWorks.subtitle": "กระบวนการที่เรียบง่ายของเราทำให้การสร้างคำตอบที่เป็นมืออาชีพสำหรับทุกสถานการณ์เป็นเรื่องง่าย",
  "howItWorks.step1.title": "เลือกสถานการณ์",
  "howItWorks.step1.description": "เลือกสถานการณ์การสื่อสารที่เหมาะสมกับความต้องการของคุณมากที่สุด",
  "howItWorks.step2.title": "วางเนื้อหา",
  "howItWorks.step2.description": "เพิ่มข้อความหรือเนื้อหาที่คุณต้องตอบกลับ",
  "howItWorks.step3.title": "รับคำตอบ AI",
  "howItWorks.step3.description": "รับคำตอบที่เป็นมืออาชีพและเหมาะสมกับบริบทในไม่กี่วินาที",

  // Pricing Section
  "pricing.title": "ราคา",
  "pricing.subtitle": "เลือกแผนที่เหมาะกับความต้องการการสื่อสารของคุณ",
  "pricing.plan.free": "Free",
  "pricing.plan.pro": "Pro",
  "pricing.plan.business": "Enterprise",
  "pricing.free.price": "$0",
  "pricing.pro.price": "$9.99",
  "pricing.business.price": "$29.99",
  "pricing.period": "/เดือน",
  "pricing.free.description": "เหมาะสำหรับการทดลองใช้บริการของเรา",
  "pricing.pro.description": "เหมาะสำหรับผู้เชี่ยวชาญและผู้ใช้บ่อย",
  "pricing.business.description": "สำหรับทีมและองค์กร",
  "pricing.popular": "ยอดนิยมที่สุด",
  "pricing.free.feature1": "10 คำตอบต่อเดือน",
  "pricing.free.feature2": "สถานการณ์พื้นฐาน",
  "pricing.free.feature3": "กำหนดและใช้เทมเพลต",
  "pricing.free.feature4": "บันทึกคำตอบในอดีต",
  "pricing.pro.feature1": "200 คำตอบต่อเดือน",
  "pricing.pro.feature2": "สถานการณ์พื้นฐาน+กำหนดเอง",
  "pricing.pro.feature3": "กำหนดและใช้เทมเพลต",
  "pricing.pro.feature4": "บันทึกคำตอบในอดีต",
  "pricing.pro.feature5": "การปรับแต่งขั้นสูง",
  "pricing.business.feature1": "คำตอบไม่จำกัด",
  "pricing.business.feature2": "การทำงานร่วมกันของทีม",
  "pricing.business.feature3": "สถานการณ์พื้นฐาน+กำหนดเอง",
  "pricing.business.feature4": "กำหนดและใช้เทมเพลต",
  "pricing.business.feature5": "บันทึกคำตอบในอดีต",
  "pricing.business.feature6": "การปรับแต่งขั้นสูง",
  "pricing.cta.trial": "เริ่มทดลองใช้ฟรี",
  "pricing.cta.subscribe": "สมัครสมาชิก",
  "pricing.cta.contact": "ติดต่อฝ่ายขาย",
  "pricing.cta.current": "แผนปัจจุบัน",
  "pricing.currentPlan": "แผนปัจจุบัน:",
  "pricing.endDate": "วันที่สิ้นสุดแผนปัจจุบัน:",
  "pricing.autoRenewalDate": "วันที่ต่ออายุอัตโนมัติของแผนปัจจุบัน:",
  "pricing.answersLeft": "คำตอบที่เหลือ:",
  "pricing.planName.free": "แผน Free",
  "pricing.planName.proMonthly": "แผน Pro-รายเดือน",
  "pricing.planName.proYearly": "แผน Pro-รายปี",
  "pricing.planName.maxMonthly": "แผน Enterprise-รายเดือน",
  "pricing.planName.maxYearly": "แผน Enterprise-รายปี",
  "pricing.autoRenews": "จำนวนคำตอบของคุณจะต่ออายุอัตโนมัติในวันที่:",
  "pricing.needMore": "ต้องการคำตอบเพิ่มเติม?",
  "pricing.upgradeBelow": "อัปเกรดแผนของคุณด้านล่าง",
  "pricing.doNotRollOver": "คำตอบที่ไม่ได้ใช้จะไม่ถูกโอนไป",
  "pricing.willCancelOn": "จะถูกยกเลิกในวันที่:",
  "pricing.downgradeScheduled": "กำหนดการดาวน์เกรด กำลังจะเปลี่ยนเป็น",
  "pricing.on": "ในวันที่:",
  "pricing.upgradeImmediateTitle": "อัปเกรดแผนแล้ว",
  "pricing.upgradeImmediateDesc": "แผนใหม่ของคุณใช้งานแล้ว",
  "pricing.downgradeScheduledTitle": "กำหนดการดาวน์เกรด",
  "pricing.downgradeScheduledDesc": "แผนของคุณจะเปลี่ยนแปลงในการต่ออายุครั้งต่อไป",
  "pricing.cancelScheduledTitle": "กำหนดการยกเลิก",
  "pricing.cancelScheduledDesc": "แผนของคุณจะสิ้นสุดในวันสิ้นสุดรอบระยะเวลา",
  "pricing.cancelResumedTitle": "ลบการยกเลิกแล้ว",
  "pricing.cancelResumedDesc": "การสมัครสมาชิกของคุณจะยังคงต่ออายุ",
  "pricing.cancelPendingDowngrade": "ยกเลิก",
  "pricing.pendingDowngradeCanceledTitle": "ยกเลิกการดาวน์เกรดที่รอดำเนินการแล้ว",
  "pricing.pendingDowngradeCanceledDesc": "แผนของคุณจะยังคงไม่เปลี่ยนแปลง",
  "pricing.pendingDowngradeCancelFailedTitle": "การยกเลิกล้มเหลว",
  "pricing.pendingDowngradeCancelFailedDesc": "ไม่สามารถยกเลิกการดาวน์เกรดที่รอดำเนินการ โปรดลองอีกครั้ง",
  "pricing.cancelPendingDowngradeProcessing": "กำลังประมวลผล...",
  "pricing.scheduled": "กำหนดการแล้ว",
  "pricing.processing": "กำลังประมวลผล...",
  "pricing.getMoreReplies": "รับคำตอบเพิ่มเติม",
  "pricing.oneTimeTitle": "รับคำตอบเพิ่มเติมสำหรับบัญชีของคุณ",
  "pricing.oneTimeAmountLabel": "จำนวนเงิน (USD)",
  "pricing.repliesUnit": "คำตอบ",
  "pricing.oneTimeNotice": "จำนวนคำตอบที่คุณซื้อจะมีผลในรอบเดือนปัจจุบัน จำเป็นต้องมีการสมัครสมาชิกแบบชำระเงินที่ใช้งานอยู่เพื่อใช้งาน และคำตอบที่ไม่ได้ใช้จะไม่ถูกโอนไป",
  "pricing.cancel": "ยกเลิก",
  "pricing.proceed": "ดำเนินการ",
  "pricing.confirmUpgradeTitle": "ยืนยันการอัปเกรด",
  "pricing.confirmDowngradeTitle": "ยืนยันการดาวน์เกรด",
  "pricing.confirmUpgradeDesc": "คุณกำลังจะอัปเกรดแผนของคุณ การเปลี่ยนแปลงจะมีผลทันที และอาจมีการเรียกเก็บเงิน (หรือเครดิต) ตามสัดส่วน",
  "pricing.confirmDowngradeDesc": "คุณกำลังจะกำหนดการดาวน์เกรด คุณลักษณะปัจจุบันของคุณจะยังคงมีผลจนกว่าจะสิ้นสุดรอบบิลปัจจุบัน",
  "pricing.downgradeEffectNote": "การดาวน์เกรดจะไม่คืนเงินรอบปัจจุบัน",
  "pricing.downgradeApplyNextCycle": "แผนใหม่จะเริ่มต้นอัตโนมัติเมื่อต่ออายุ",
  "pricing.confirmCancel": "กลับ",
  "pricing.confirmProceedUpgrade": "อัปเกรดตอนนี้",
  "pricing.confirmProceedDowngrade": "กำหนดการดาวน์เกรด",

  // FAQ Section
  "faq.title": "คำถามที่พบบ่อย",
  "faq.subtitle": "ทุกสิ่งที่คุณต้องรู้เกี่ยวกับ communicate2win",
  "faq.q1": "รองรับสถานการณ์การสื่อสารใดบ้าง?",
  "faq.a1": "เราสนับสนุนการสื่อสารในที่ทำงาน ความสัมพันธ์ส่วนตัว การสื่อสารทางวิชาการ การบริการลูกค้า การเข้าถึงการขาย และสถานการณ์อื่นๆ อีกมากมาย AI ของเราจะปรับตัวให้เข้ากับบริบทและน้ำเสียงที่จำเป็นสำหรับแต่ละสถานการณ์",
  "faq.q2": "คำตอบถูกสร้างขึ้นเร็วแค่ไหน?",
  "faq.a2": "AI ของเราสร้างคำตอบในไม่กี่วินาที เราให้ความสำคัญกับความเร็วโดยไม่เสียคุณภาพ เพื่อให้คุณได้รับคำตอบที่เป็นมืออาชีพทันที",
  "faq.q3": "ฉันสามารถยกเลิกการสมัครสมาชิกได้ตลอดเวลาหรือไม่?",
  "faq.a3": "ใช่ คุณสามารถยกเลิกการสมัครสมาชิกได้ตลอดเวลา ไม่มีการผูกมัดระยะยาว และคุณสามารถดาวน์เกรดหรืออัปเกรดแผนของคุณตามความจำเป็น",
  "faq.q4": "ข้อมูลของฉันปลอดภัยและเป็นส่วนตัวหรือไม่?",
  "faq.a4": "ใช่ เราใช้มาตรการรักษาความปลอดภัยอย่างครอบคลุม รวมถึงการเข้ารหัส การควบคุมการเข้าถึง และการตรวจสอบความปลอดภัยประจำ เราเก็บเนื้อหาที่คุณป้อนและคำตอบที่สร้างขึ้นเป็นส่วนหนึ่งของประวัติผู้ใช้ของคุณ เพื่อเปิดใช้งานคุณลักษณะต่างๆ เช่น การตรวจสอบคำตอบและการสร้างเทมเพลต คุณสามารถลบข้อมูลประวัติของคุณได้ตลอดเวลาผ่านการตั้งค่าบัญชีของคุณ",
  "faq.q5": "หาก Replies หมดจะทำอย่างไร?",
  "faq.a5": "ผู้ใช้ Free ต้องรอรอบเดือนถัดไปเพื่อรีเฟรชโควตา หลังอัปเกรดเป็น Pro หาก Replies ไม่พอสามารถซื้อ Replies เพิ่มแบบครั้งเดียวได้; Replies ที่ซื้อเพิ่มใช้ได้เฉพาะรอบเดือนปัจจุบัน ผู้ใช้ Enterprise มี Replies ไม่จำกัด",
  "faq.q6": "รองรับภาษาใดบ้าง?",
  "faq.a6": "ขณะนี้เราสนับสนุนภาษาอังกฤษ พร้อมแผนขยายไปยังภาษาสเปน ฝรั่งเศส เยอรมัน และภาษาหลักอื่นๆ AI สามารถจัดการการสื่อสารหลายภาษาได้อย่างมีประสิทธิภาพ",

  // Testimonials Section
  "testimonials.title": "โชว์เคสการสื่อสาร",
  "testimonials.subtitle": "ข้อความสาธารณะ อีเมล และคำตอบที่ปรับปรุงด้วย AI เพื่อสร้างแรงบันดาลใจให้กับคุณ",
  "testimonials.sarah.name": "ซาราห์ จอห์นสัน",
  "testimonials.sarah.title": "ผู้อำนวยการฝ่ายการตลาด",
  "testimonials.sarah.quote": "communicate2win เปลี่ยนวิธีที่ฉันจัดการการสื่อสารกับลูกค้า คำตอบมีความเป็นมืออาชีพและช่วยประหยัดเวลาให้ฉันหลายชั่วโมงต่อสัปดาห์",
  "testimonials.michael.name": "ไมเคิล เชน",
  "testimonials.michael.title": "ผู้จัดการฝ่ายขาย",
  "testimonials.michael.quote": "เทมเพลตสถานการณ์ในที่ทำงานมีความแม่นยำอย่างน่าทึ่ง อัตราการตอบกลับของฉันดีขึ้น 40% ตั้งแต่เริ่มใช้เครื่องมือนี้",
  "testimonials.emily.name": "เอมิลี่ โรดริเกซ",
  "testimonials.emily.title": "หัวหน้าฝ่ายความสำเร็จของลูกค้า",
  "testimonials.emily.quote": "เหมาะมากสำหรับจัดการสถานการณ์ลูกค้ายาก AI เข้าใจบริบทและน้ำเสียงได้อย่างสมบูรณ์แบบ",
  "testimonials.more": "คลิกที่แกลเลอรี่เพื่อสำรวจโชว์เคสทั้งหมด",

  // Interface Elements
  "interface.generating": "กำลังสร้างคำตอบ...",
  "interface.generate": "สร้างคำตอบ AI",
  "interface.processing": "กำลังประมวลผล...",
  "interface.advancedOptions": "ตัวเลือกขั้นสูง",
  "interface.clearInput": "ล้างข้อมูลที่ป้อน",
  "interface.clearDescription": "ล้างคำอธิบาย",
  // Marquee / Logos
  "marquee.trusted": "พันธมิตร / การสนับสนุน",
  "marquee.aria": "โลโก้แบรนด์",

  // History and Showcase
  "history.shareToShowcase": "แชร์ไปยังโชว์เคส",
  "history.showcased": "ในโชว์เคส",
  "history.shareConfirm": "แชร์โพสต์นี้ไปยังโชว์เคส? การกระทำนี้ไม่สามารถย้อนกลับได้เว้นแต่คุณจะลบโพสต์",
  "history.sharedBy": "แชร์โดย:",
  "interface.copy": "คัดลอก",
  "interface.share": "แชร์",
  "interface.shareResponse": "แชร์คำตอบ",
  "interface.shareNative": "แชร์ผ่านระบบ",
  "interface.shareEmail": "อีเมล",
  "interface.copyShareText": "คัดลอกพร้อมลิงก์",
  "interface.shareTextCopied": "คำตอบและลิงก์ถูกคัดลอกไปยังคลิปบอร์ดแล้ว",
  "interface.ready": "พร้อมสร้าง",
  "interface.enterMessage": "ป้อนเนื้อหาข้อความของคุณและเลือกสถานการณ์เพื่อเริ่มต้นใช้งานคำตอบที่ขับเคลื่อนด้วย AI",
  "interface.fast": "รวดเร็ว",
  "interface.accurate": "แม่นยำ",
  "interface.professional": "เป็นมืออาชีพ",
  "interface.translation": "แปลภาษา",
  "interface.responseDescription": "นี่คือคำตอบที่พิจารณาอย่างรอบคอบและเป็นมืออาชีพที่ปรับให้เหมาะสมกับบริบท:",
  "interface.multipleOptions": "ตัวเลือกคำตอบหลายรายการ:",
  "interface.option": "ตัวเลือก",
  "interface.noContent": "ไม่มีเนื้อหาที่ใช้ได้",

  // Placeholders
  "placeholder.message": "วางข้อความที่คุณกำลังตอบกลับ เนื้อหาอีเมล หรือข้อความที่คุณได้รับ...",

  // Dropdowns
  "dropdown.useTemplates": "ใช้เทมเพลต",
  "dropdown.scenario": "ไม่มีสถานการณ์",
  "dropdown.target": "ไม่มีเป้าหมาย",
  "dropdown.tone": "ไม่มีโทน",

  // Scenario Options
  "scenario.email": "อีเมล",
  "scenario.message": "ข้อความ",
  "scenario.workplace": "ที่ทำงาน",
  "scenario.school": "โรงเรียน",
  "scenario.home": "บ้าน",
  "scenario.business": "ธุรกิจ",
  "scenario.academic": "วิชาการ",
  "scenario.social": "สังคม",
  "scenario.formal": "เป็นทางการ",
  "scenario.casual": "ไม่เป็นทางการ",
  "scenario.professional": "เป็นมืออาชีพ",
  "scenario.personal": "ส่วนตัว",
  "scenario.customerService": "บริการลูกค้า",
  "scenario.interview": "สัมภาษณ์",
  "scenario.presentation": "การนำเสนอ",

  // Target Options
  "target.lover": "คนรัก",
  "target.friend": "เพื่อน",
  "target.boss": "หัวหน้า",
  "target.colleague": "เพื่อนร่วมงาน",
  "target.classmate": "เพื่อนร่วมชั้น",
  "target.parents": "พ่อแม่",
  "target.child": "ลูก",
  "target.teacher": "ครู",
  "target.student": "นักเรียน",
  "target.client": "ลูกค้า",
  "target.customer": "ลูกค้า",
  "target.stranger": "คนแปลกหน้า",
  "target.family": "ครอบครัว",
  "target.sibling": "พี่น้อง",
  "target.neighbor": "เพื่อนบ้าน",
  "target.mentor": "ที่ปรึกษา",
  "target.supplier": "ผู้จัดหา",
  "target.serviceProvider": "ผู้ให้บริการ",
  "target.partner": "พันธมิตร",
  "target.subordinate": "ลูกน้อง",

  // Tone Options
  "tone.humorous": "ขบขัน",
  "tone.serious": "จริงจัง",
  "tone.happy": "มีความสุข",
  "tone.angry": "โกรธ",
  "tone.mischievous": "ซุกซน",
  "tone.polite": "สุภาพ",
  "tone.casual": "ไม่เป็นทางการ",
  "tone.formal": "เป็นทางการ",
  "tone.friendly": "เป็นมิตร",
  "tone.confident": "มั่นใจ",
  "tone.apologetic": "ขอโทษ",
  "tone.enthusiastic": "กระตือรือร้น",

  // Status Messages
  "status.copied": "คัดลอกแล้ว!",
  "status.copyDescription": "คำตอบถูกคัดลอกไปยังคลิปบอร์ดแล้ว",
  "status.copyWithTranslationDescription": "คำตอบและคำแปลถูกคัดลอกไปยังคลิปบอร์ดแล้ว",
  "status.success": "สร้างคำตอบสำเร็จ",
  "status.successWithTranslation": "สร้างคำตอบพร้อมคำแปลแล้ว",
  "status.successWithoutTranslation": "สร้างคำตอบสำเร็จ",
  "status.error": "การสร้างล้มเหลว",
  "status.errorDescription": "ไม่สามารถสร้างคำตอบ โปรดลองอีกครั้ง",
  "status.enterContent": "กรุณาใส่เนื้อหา",
  "status.enterContentDescription": "เพิ่มข้อความที่คุณต้องการตอบกลับ",

  // Pro/Max subscriber restrictions
  "restriction.descriptionOptional": "คำอธิบาย (ไม่บังคับ)",
  "restriction.descriptionLabel": "คำอธิบาย (สำหรับสมาชิก Pro / Enterprise เท่านั้น)",
  "restriction.proMaxOnly": "* สำหรับสมาชิก Pro / Enterprise เท่านั้น",
  "restriction.desPrompt": "ป้อนบริบท ข้อมูลพื้นหลัง หรือข้อกำหนดเฉพาะที่สามารถช่วยสร้างคำตอบที่ดีขึ้น...",

  // Demo functionality for non-logged-in users
  "demo.title": "เลือกข้อความที่จะตอบกลับ",
  "demo.option1": "การเปิดการขาย (การติดต่อแบบเย็นชา)",
  "demo.option2": "การจัดการกับการสอบถาม \"ราคาของคุณสูง\"",
  "demo.option3": "การแนะนำตัวในการสัมภาษณ์ (เวอร์ชัน 30 วินาที)",
  "demo.option4": "การตอบกลับอีเมล",
  "demo.option5": "การติดตามลูกค้าที่มีแนวโน้ม \"อ่านแล้วแต่ไม่ตอบ\"",
  "demo.option6": "Elevator pitch (30 วินาที)",
  "demo.runDemo": "เรียกใช้เดโม",
  "demo.inputContent": "เนื้อหาที่ป้อน:",
  "demo.scenario": "สถานการณ์:",
  "demo.target": "เป้าหมาย:",
  "demo.tone": "โทน:",
  "demo.description": "คำอธิบาย:",

  // Showcase Page
  "showcase.title": "โชว์เคสการสื่อสาร",
  "showcase.subtitle": "ค้นพบการสื่อสารที่สร้างแรงบันดาลใจด้วย AI ที่แชร์โดยชุมชนของเรา",
  "showcase.userPrefix": "การสื่อสารสาธารณะโดย",
  "showcase.backAll": "กลับไปที่โชว์เคสทั้งหมด",
  "showcase.sortBy": "เรียงตาม:",
  "showcase.sort.newest": "ใหม่ที่สุดก่อน",
  "showcase.sort.oldest": "เก่าที่สุดก่อน",
  "showcase.sort.scenario": "ตามสถานการณ์",
  "showcase.sort.target": "ตามเป้าหมาย",
  "showcase.sort.tone": "ตามโทน",
  "showcase.filter.scenario": "สถานการณ์:",
  "showcase.filter.target": "เป้าหมาย:",
  "showcase.filter.tone": "โทน:",
  "showcase.filter.all": "ทั้งหมด",
  "showcase.loading": "กำลังโหลดโชว์เคส...",
  "showcase.loadingUser": "กำลังโหลดการสื่อสารของผู้ใช้...",
  "showcase.loadingMore": "กำลังโหลดเพิ่มเติม...",
  "showcase.none.userTitle": "ยังไม่มีการสื่อสารสาธารณะ",
  "showcase.none.globalTitle": "ยังไม่มีรายการโชว์เคส",
  "showcase.none.userDesc": "ผู้ใช้รายนี้ยังไม่ได้แชร์การสื่อสารใดๆ ในโชว์เคส",
  "showcase.none.globalDesc": "เป็นคนแรกที่แชร์การสื่อสารด้วย AI ของคุณในโชว์เคส!",
  "showcase.messageDetails": "รายละเอียดข้อความ",
  "showcase.field.date": "วันที่",
  "showcase.field.scenario": "สถานการณ์",
  "showcase.field.target": "เป้าหมาย",
  "showcase.field.tone": "โทน",
  "showcase.originalMessage": "ข้อความต้นฉบับ",
  "showcase.description": "คำอธิบาย",
  "showcase.aiResponse": "คำตอบ AI",

  // Templates
  "templates.saveAsTemplate": "บันทึกเป็นเทมเพลต",
  "templates.saved": "บันทึกเทมเพลตแล้ว",
  "templates.saveSuccess": "บันทึกเทมเพลตสำเร็จ",
  "templates.title": "เทมเพลตของฉัน",
  "templates.new": "เทมเพลตใหม่",
  "templates.loading": "กำลังโหลด...",
  "templates.none": "ไม่พบเทมเพลต",
  "templates.name": "ชื่อ",
  "templates.scenario": "สถานการณ์",
  "templates.target": "เป้าหมาย",
  "templates.tone": "โทน",
  "templates.description": "คำอธิบาย",
  "templates.save": "บันทึก",
  "templates.saving": "กำลังบันทึก...",
  "templates.delete": "ลบเทมเพลต",
  "templates.deleteConfirm": "ลบเทมเพลตนี้?",
  "templates.deleteFailed": "ไม่สามารถลบเทมเพลตได้",
  "templates.nameRequired": "* กรุณาป้อนชื่อเทมเพลต",
  "templates.deleteSuccess": "ลบเทมเพลตสำเร็จ",

  // History Modal additions
  "history.messageDetails": "รายละเอียดข้อความ",
  "history.messageDetailsDesc": "ดูและจัดการรายละเอียดข้อความ รวมถึงข้อมูลที่ป้อนต้นฉบับและคำตอบที่สร้างด้วย AI",
  "history.field.date": "วันที่",
  "history.field.scenario": "สถานการณ์",
  "history.field.target": "เป้าหมาย",
  "history.field.tone": "โทน",
  "history.originalMessage": "ข้อความต้นฉบับ",
  "history.aiResponse": "คำตอบ AI",
  "history.description": "คำอธิบาย",
  "history.listTitle": "ประวัติข้อความ",
  "history.listDesc": "เรียกดู คัดกรอง และจัดการประวัติการสนทนาของคุณ คลิกที่ข้อความใดก็ได้เพื่อดูรายละเอียด",
  "history.sortBy": "เรียงตาม:",
  "history.sort.newest": "ใหม่ที่สุดก่อน",
  "history.sort.oldest": "เก่าที่สุดก่อน",
  "history.sort.scenario": "ตามสถานการณ์",
  "history.sort.target": "ตามเป้าหมาย",
  "history.sort.tone": "ตามโทน",
  "history.filter.scenario": "สถานการณ์:",
  "history.filter.target": "เป้าหมาย:",
  "history.filter.tone": "โทน:",
  "history.filter.all": "ทั้งหมด",
  "history.loading": "กำลังโหลดประวัติ...",
  "history.loadingMore": "กำลังโหลดเพิ่มเติม...",
  "history.none": "ไม่พบข้อความ",
  "history.showing": "แสดง {current} จาก {total} ข้อความ",
  "history.allLoaded": "โหลดข้อความทั้งหมดแล้ว",
  "history.scrollMore": "เลื่อนลงเพื่อดูเพิ่มเติม",
  "history.loadMoreButton": "โหลดเพิ่มเติม",
  "history.deleteMessage": "ลบข้อความ",
  "history.deleting": "กำลังลบ...",
  "history.deleteSuccess": "ลบบันทึกข้อความสำเร็จ",
  "history.deleteFailed": "ไม่สามารถลบบันทึกข้อความ โปรดลองอีกครั้ง",
  "history.confirmDeleteTitle": "ยืนยันการลบ",
  "history.confirmDeleteSubtitle": "การกระทำนี้ไม่สามารถย้อนกลับได้",
  "history.confirmDeleteDesc": "คุณแน่ใจหรือไม่ว่าต้องการลบบันทึกข้อความนี้?",
  "history.confirmDeleteAction": "ยืนยันการลบ",
  "history.shareTitle": "แชร์ไปยังโชว์เคส",
  "history.shareSubtitle": "ทำให้ข้อความนี้เป็นสาธารณะ",
  "history.sharing": "กำลังแชร์...",
  "history.confirmShareAction": "ยืนยันการแชร์",
  "history.shareSuccess": "แชร์ข้อความไปยังโชว์เคสสำเร็จ",
  "history.shareFailed": "ไม่สามารถแชร์ไปยังโชว์เคส โปรดลองอีกครั้ง",
  "templates.saveFailed": "ไม่สามารถบันทึกเทมเพลตได้",

  // User Menu
  "userMenu.myAccount": "บัญชีของฉัน",
  "userMenu.history": "ประวัติ",
  "userMenu.templates": "เทมเพลต",
  "userMenu.signOut": "ออกจากระบบ",
  
  // Hero Showcase / Demo Tabs / Previews
  "hero.preview.aiReply": "ดูตัวอย่างคำตอบ AI",
  "hero.preview.scenarioLabel": "สถานการณ์",
  // Demo short tab titles (mapped from demo option ids)
  "demo.shortTitle.salesOpener": "การเปิดการขาย",
  "demo.shortTitle.priceObjection": "ข้อโต้แย้งเรื่องราคา",
  "demo.shortTitle.interviewIntro": "บทนำในการสัมภาษณ์",
  "demo.shortTitle.emailReply": "ตอบกลับอีเมล",
  "demo.shortTitle.followUp": "ติดตาม",
  "demo.shortTitle.elevatorPitch": "Elevator pitch",
  // Demo path / response overlay
  "demoTabs.pathPrefix": "demo",
  "demoTabs.response": "response",
  "demoTabs.inputPrompt": "INPUT PROMPT",
  "demoTabs.context": "CONTEX",
  "demoTabs.description": "คำอธิบาย",
  "demoTabs.generate": "สร้าง",
  "demoTabs.aiOutput": "เอาต์พุต AI",
  "demoTabs.sample": "ตัวอย่าง",
  "demoTabs.streaming": "กำลังสตรีมโทเคน...",
  "preview.section.scenarioTemplates.title": "สถานการณ์และเทมเพลต",
  "preview.section.scenarioTemplates.subtitle": "เลือกสถานการณ์อย่างรวดเร็วหรือใช้เทมเพลตที่บันทึกไว้ เทมเพลตจะกรอกคำอธิบาย/เป้าหมาย/โทนล่วงหน้า เพื่อให้คุณเข้าสู่การสร้างคุณภาพสูงได้ทันที",
  "preview.section.customInputs.title": "ข้อมูลที่กำหนดเอง",
  "preview.section.customInputs.subtitle": "ข้อมูลหลัก + คำอธิบายเพิ่มเติม + เครื่องมือเลือกสถานการณ์/เป้าหมาย/โทนขั้นสูง รวมเข้าด้วยกันอย่างอิสระเพื่อให้ได้ผลลัพธ์ที่เข้าใจบริบท",
  "preview.section.cutReplyTime.title": "ลดเวลาตอบกลับ 90%",
  "preview.section.cutReplyTime.subtitle": "เปรียบเทียบการร่างด้วยตนเองกับความช่วยเหลือด้วย AI ตัวเลือกแบบขนาน + วงจรการแปลหรือการแก้ไขที่มีในตัว",
  "preview.section.copyShare.title": "คัดลอกและแชร์ในคลิกเดียว",
  "preview.section.copyShare.subtitle": "ตัวเลือกหลายรายการจัดเรียงด้วยการกระทำด้านบนที่เป็นหนึ่งเดียว: คัดลอกทั้งหมด / แชร์ / คัดลอกต่อตัวเลือก คำแปลจะถูกแนบโดยอัตโนมัติ",
  "preview.templates.my": "เทมเพลตของฉัน",
  "preview.templates.new": "ใหม่",
  "preview.manualFlow": "โฟลว์ด้วยตนเอง",
  "preview.aiAssisted": "ได้รับความช่วยเหลือจาก AI",
  // Manual flow bullet steps
  "preview.manualFlow.step1": "วางแผนโครงสร้างและโทน",
  "preview.manualFlow.step2": "ร่างคำเปิด / ลบและเขียนใหม่",
  "preview.manualFlow.step3": "ปรับแต่งมารยาทและไวยากรณ์",
  "preview.manualFlow.step4": "ค้นหาคำศัพท์ + ตรวจสอบคำแปล",
  "preview.manualFlow.step5": "วางในแอปเป้าหมาย",
  "preview.copyAll": "คัดลอกทั้งหมด",
  "preview.share": "แชร์",
  "preview.enPlusTranslation": "EN + คำแปล",
  "preview.translationAppendNote": "(*) คำแปลจะถูกแนบโดยอัตโนมัติเมื่อคัดลอกทั้งหมด",
  "preview.field.scenario": "สถานการณ์",
  "preview.field.target": "เป้าหมาย",
  "preview.field.tone": "โทน",
  "preview.auto": "อัตโนมัติ",
  "preview.step.pasteOrTemplate": "วางคำขอหรือเลือกเทมเพลต",
  "preview.step.optionalDescription": "(ไม่บังคับ) เพิ่มคำอธิบาย/สถานการณ์",
  "preview.step.pickOption": "เลือกหนึ่งในตัวเลือกที่สร้างขึ้น",
  "preview.step.copyShareTranslate": "คัดลอก/แชร์/แปลในคลิกเดียว",
  "preview.time.manual": "5–8 นาที",
  "preview.time.ai": "30–40 วินาที"
};